import { EXCEL_FILE_TYPES } from '@autone/utils';
import { z } from 'zod';

import { aggregationType } from '../aggregation-type-radio-toggle-group';

export const uploadAssortmentTemplateFormSchema = z.object({
  aggregationType: aggregationType,
  file: z
    .instanceof(File)
    .refine((file) => Object.keys(EXCEL_FILE_TYPES).includes(file.type), {
      message: 'Invalid file type',
    }),
});

export type UploadAssortmentTemplateFormSchema = z.infer<
  typeof uploadAssortmentTemplateFormSchema
>;
